import React, { ChangeEvent } from "react";
import { Form } from "react-bootstrap";
import { StringWithFormat } from "../../../types/Result";

interface layoutOption {
    value: number
    label: string
    image: string
}

export interface IProps {
    name: string,
    value: number,
    disabled?: boolean
    validationResults?: StringWithFormat[]
    onChange: (value: any) => void
    onBlur?: () => void
    option: layoutOption
}

const RadioButtonListItem: React.FC<IProps> = ({ name, value, disabled, validationResults, onChange, onBlur, option }) => {

    function onControlChange(e: ChangeEvent<HTMLInputElement>) {
        onChange(option.value);
    }

    function onClick() { 
        onChange(option.value);
    }

    let isValid = validationResults && validationResults.length > 0 ? false : true;
    let isSelected = value === option.value

    return (
        <div style={{ marginTop: 10, marginRight: 10, display: 'inline-block', border: isSelected ? '1px solid black' : '' }} className='pull-left' onClick={onClick}>
            <img src={option.image} height={60} width={90} style={{ marginBottom:5 }} />
            <div>
                <Form.Control type='radio' name={name} value={option.value} checked={option.value == value} disabled={disabled} onChange={onControlChange} isInvalid={!isValid} onBlur={onBlur} style={{ height: 20, width: 20, marginRight: 5 }} className="pull-left" />
                {option.label}
            </div>
        </div>
    )

}
export default RadioButtonListItem;